import styled from '@emotion/styled';
import { dropDownAccessibilityButton } from '../DropDownMenu/styles';
import Link from '../Link';
import { mobileOnly } from '../../utils/sharedStyles';

export const linkColumnListItem = 'dropdown__sub_list_item';
export const subFooterLink = 'sub-footer-link';
export const footerList = 'footer-list';
export const isOpen = 'is-open';
export const footerDropDown = 'footer-drop-down';
export const linkContainer = 'link-container';

export const SubFooterDropDownContainer = styled.div`
  .${linkContainer} {
    margin: 0;
    width: 100%;
  }
  .${linkColumnListItem} {
    padding: 6px 12px;
    &:hover {
      background-color: var(--podium-cds-color-bg-hover);
      p {
        color: var(--podium-cds-color-text-primary);
      }
    }
    & > a > p {
      padding: 0;
    }
  }
  position: relative;
  display: flex;
  align-items: center;
  .${footerDropDown} {
    background-color: var(--podium-cds-color-bg-primary);
    right: auto;
    left: -13px;
    top: auto;
    position: absolute;
    transform: translateY(-100%);
    border-radius: 8px;
    width: 200px;
    padding: 8px 0;
    border: 1px solid var(--podium-cds-color-border-tertiary);
    box-shadow: 0px 4px 8px 0px rgba(17, 17, 17, 0.06), 0px 0px 24px 4px rgba(17, 17, 17, 0.03);
    &.is--open {
      transform: translateY(-104%);
    }
    @media (${mobileOnly}) {
      transform: translateY(-106%);
      right: auto;
      left: -13px;
    }
    .Column {
      width: auto;
    }
  }
`;

export const SubFooterLink = styled(Link)`
  display: flex;
  img {
    padding: 0 4px 0 0;
  }
  p {
    color: var(--podium-cds-color-text-secondary);
  }
  &:hover {
    p {
      color: var(--podium-cds-color-text-primary);
    }
  }
`;

export const StyledSubFooter = styled.div`
  padding-bottom: 48px;
  .${footerList} {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 24px;
    row-gap: 12px;
    flex-wrap: wrap;
    position: static;
    border-top: 1px solid transparent;
    @media (${mobileOnly}) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 10px;
      align-self: stretch;
      padding-bottom: 0px;
    }
    .${dropDownAccessibilityButton} {
      display: flex;
      align-items: center;
      opacity: 1;
      color: var(--podium-cds-color-text-secondary);
      svg {
        width: auto;
      }
    }

    details[open] {
      > summary {
        color: var(--podium-cds-color-text-primary);
      }
    }
  }
`;

export const CopyrightListItem = styled.li`
  white-space: nowrap;
`;
